import angular from 'angular';
import template from './template.html';
import './style.scss';

export class EmailSummary {

}

export const emailSummaryConfiguration = {
    template,
    bindings: {
        summary: '<',
        onDone: '&',
    },
    controller: EmailSummary,
    controllerAs: 'emailSummaryCtrl',
};

angular.module('TALENYA-FE').component('emailSummary', emailSummaryConfiguration);